import * as checkHelpers from 'src/helpers/check';
import * as stringHelpers from 'src/helpers/string';
import * as transformHelpers from 'src/helpers/transform';
import * as azure from 'src/helpers/azure';
import * as load from 'src/helpers/load';
import * as formValidation from 'src/helpers/formValidation';
import * as permissions from 'src/helpers/permissions';
import * as formOptions from 'src/helpers/formOptions';
import * as chat from 'src/helpers/chat';
import * as checkMessageSendHours from 'src/helpers/checkMessageSendHours';
import { linkifyText } from 'src/helpers/linkifyText';
import { createDynamicFieldObj } from 'src/helpers/dynamicFields';
import {
  normalizeFontSizeForTypography,
  normalizeFontSizeToPx,
} from 'src/helpers/fontStyles';
import { stripHtml, truncate } from 'src/helpers/stripHtml';

export default {
  ...checkHelpers,
  ...stringHelpers,
  transform: transformHelpers,
  azure,
  chat,
  load,
  formValidation,
  permissions,
  formOptions,
  checkMessageSendHours,
  linkifyText,
  createDynamicFieldObj,
  normalizeFontSizeForTypography,
  normalizeFontSizeToPx,
  stripHtml,
  truncate,
};
